import AvatarsList from 'core/modules/components/lists/AvatarsList';
import PropTypes from 'prop-types';
import React from 'react';

const HorizontalStudentsProgress = ({ students, t, scoreScale }) => {
  const progressPointsAll = students.map((item) => item.progress);
  const progressPointsList = progressPointsAll.filter((item, index) => {
    return progressPointsAll.indexOf(item) === index;
  });

  let studentsSortedByProgress = [];

  progressPointsList.forEach((element) => {
    studentsSortedByProgress.push(
      students.filter((item) => {
        return item.progress === element;
      })
    );
  });

  return (
    <div className="horizontal-students-progress">
      <div className="horizontal-students-progress__wrapper">
        {studentsSortedByProgress.map((studentsList, index) => {
          let positionFix;
          if (studentsList.length === 1) {
            positionFix = 16;
          } else if (studentsList.length === 2) {
            positionFix = 32;
          } else {
            positionFix = 48;
          }
          return (
            <div key={index} className="horizontal-students-progress__item" style={{ left: `calc(${studentsList[0].progress} - ${positionFix}px` }}>
              <div className="horizontal-students-progress__item-hover">{parseFloat(studentsList[0].progress).toFixed(1) + '%'}</div>
              <AvatarsList avatars={studentsList} withArrow={true} isScore={true} scoreScale={scoreScale} size="md" />
            </div>
          );
        })}

        <div className="horizontal-students-progress__bar">
          <span>0%</span>
          <span>{t('scorm:Progress')}</span>
          <span>100%</span>
        </div>
      </div>
    </div>
  );
};

HorizontalStudentsProgress.propTypes = {
  scoreScale: PropTypes.number,
  students: PropTypes.array,
  t: PropTypes.func,
};

export default HorizontalStudentsProgress;
